import Vue from 'vue';
//dayjs@1.8.21
import dayjs from 'dayjs';

/* eslint-disable-next-line */
require('dayjs/locale/fr');
dayjs.locale('fr');

import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import BuddhistEra from 'dayjs/plugin/buddhistEra';
import Calendar from 'dayjs/plugin/calendar';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
import DayOfYear from 'dayjs/plugin/dayOfYear';
import Duration from 'dayjs/plugin/duration';
import IsBetween from 'dayjs/plugin/isBetween';
import IsLeapYear from 'dayjs/plugin/isLeapYear';
import IsSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import IsSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import IsToday from 'dayjs/plugin/isToday';
import IsTomorrow from 'dayjs/plugin/isTomorrow';
import IsYesterday from 'dayjs/plugin/isYesterday';
import IsoWeek from 'dayjs/plugin/isoWeek';
import IsoWeeksInYear from 'dayjs/plugin/isoWeeksInYear';
import LocaleData from 'dayjs/plugin/localeData';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import MinMax from 'dayjs/plugin/minMax';
import ObjectSupport from 'dayjs/plugin/objectSupport';
import QuarterOfYear from 'dayjs/plugin/quarterOfYear';
import RelativeTime from 'dayjs/plugin/relativeTime';
import ToArray from 'dayjs/plugin/toArray';
import ToObject from 'dayjs/plugin/toObject';
import UpdateLocale from 'dayjs/plugin/updateLocale';
import UTC from 'dayjs/plugin/utc';
import WeekDay from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import WeekYear from 'dayjs/plugin/weekYear';


dayjs.extend(AdvancedFormat);
dayjs.extend(BuddhistEra);
dayjs.extend(Calendar);
dayjs.extend(CustomParseFormat);
dayjs.extend(DayOfYear);
dayjs.extend(Duration);
dayjs.extend(IsBetween);
dayjs.extend(IsLeapYear);
dayjs.extend(IsSameOrAfter);
dayjs.extend(IsSameOrBefore);
dayjs.extend(IsToday);
dayjs.extend(IsTomorrow);
dayjs.extend(IsYesterday);
dayjs.extend(IsoWeek);
dayjs.extend(IsoWeeksInYear);
dayjs.extend(LocaleData);
dayjs.extend(LocalizedFormat);
dayjs.extend(MinMax);
dayjs.extend(ObjectSupport);
dayjs.extend(QuarterOfYear);
dayjs.extend(RelativeTime);
dayjs.extend(ToArray);
dayjs.extend(ToObject);
dayjs.extend(UpdateLocale);
dayjs.extend(UTC);
dayjs.extend(WeekDay);
dayjs.extend(weekOfYear);
dayjs.extend(WeekYear);



Object.defineProperties(Vue.prototype, {
    $date: {
        get() {
            return dayjs;
        }
    }
});
